import { FC, ReactNode } from "react";
import { useRecoilValue } from "recoil";
import { activeFloorMoveState } from "../stores";
import { IfBlock } from "../components/IfBlock";
export const IfCanEs: FC<{
    children: ReactNode
}> = ({ children }) => {
    const { es: visible } = useRecoilValue(activeFloorMoveState);
    return <IfBlock visible={visible}>{children}</IfBlock>
};
